module.exports = __webpack_public_path__ + "igBrowserLogos.46f54dbfbad8b3378262.png";


//////////////////
// WEBPACK FOOTER
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/assets/img/igBrowserLogos.png
// module id = ../../../../../client/assets/img/igBrowserLogos.png
// module chunks = styles